// extracted by mini-css-extract-plugin
export var image = "title-page-module--image--a6cef";
export var svgImage = "title-page-module--svgImage--cb075";
export var ticketBlockText = "title-page-module--ticketBlockText--00267";
export var titleBlockItem = "title-page-module--titleBlockItem--a0019";
export var titleImage = "title-page-module--titleImage--08734";
export var titleRow = "title-page-module--titleRow--6f84e";
export var titleText = "title-page-module--titleText--fa7ef";